import { motion } from 'framer-motion';
import type { LucideIcon } from 'lucide-react';

interface SectionDividerProps {
  icon: LucideIcon;
  label: string;
  gradient?: string;
}

export const SectionDivider = ({ 
  icon: Icon, 
  label, 
  gradient = 'from-brand-primary/20 to-transparent' 
}: SectionDividerProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="relative py-8 mb-12"
    >
      {/* Gradient line */}
      <div className={`absolute left-0 top-1/2 -translate-y-1/2 w-full h-px bg-gradient-to-r ${gradient}`} />
      
      {/* Label with icon */}
      <div className="relative inline-flex items-center gap-3 px-6 py-3 rounded-full bg-brand-dark border border-brand-border backdrop-blur-sm">
        <div className="p-1.5 rounded-lg bg-brand-base">
          <Icon className="w-4 h-4 text-brand-primary" />
        </div>
        <span className="text-sm font-bold text-white uppercase tracking-wider font-display">
          {label}
        </span>
      </div>
    </motion.div>
  );
};
